const initialState = {
  organisation: 10,
};

function baseReducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'CHANGE_ORGANISATION':
      return {
        ...state,
        organisation: payload,
      };
    default:
      return state;
  }
}

export default baseReducer;
